import { useEffect, useState } from 'react';

import { useQuery, useStorage64 } from 'hooks';
import { useDispatch, useStore } from 'store';

import { setAgentStaffId, setAgentTableId } from 'store/actions/commons';
import { fetchGiftTableInfo } from 'store/actions/giftTable';
import Loader from 'components/Loader';

import { AGENT_STAFF, AGENT_STAFF_TOKEN } from 'constants/storage64';
import { ADMIN_QUERIES } from 'constants/params';

const WAIT_CONTEXT = 200;

export default function withAgentPage({ fetchTableInfo = false } = {}) {
  return (Component) => (props) => {
    const [hasHydrated, setHasHydrated] = useState(false);
    const dispatch = useDispatch();
    const [agentTableId] = useStore((state) => state.commons.agentTableId);
    const [agentStaffId] = useStore((state) => state.commons.agentStaffId);

    const query = useQuery();

    const queryAgentId = query.get(ADMIN_QUERIES.AGENT_STAFF);
    const queryTableId = query.get(ADMIN_QUERIES.TABLE_ID);
    const queryAgentToken = query.get(ADMIN_QUERIES.AGENT_TOKEN);
    // eslint-disable-next-line no-unused-vars
    const queryAdminheader = query.get(ADMIN_QUERIES.ADMIN_HEADER);
    sessionStorage.setItem('admin_header',queryAdminheader);

    // console.log('queryAdminheader',queryAdminheader);

    const [, setStorageAgentStaffID] = useStorage64(AGENT_STAFF, '');
    const [, setStorageAgentStaffToken] = useStorage64(AGENT_STAFF_TOKEN, '');

    useEffect(() => {
      if (queryAgentId) dispatch(setAgentStaffId(queryAgentId));
      if (queryTableId) dispatch(setAgentTableId(queryTableId));
      if (queryAgentId) setStorageAgentStaffID(queryAgentId);
      if (queryAgentToken) setStorageAgentStaffToken(queryAgentToken);

      setTimeout(() => {
        setHasHydrated(true);
      }, WAIT_CONTEXT);
    }, [queryAgentId, queryTableId, queryAgentToken]);

    useEffect(() => {
      if (fetchTableInfo && queryAgentId && queryTableId) {
        dispatch(fetchGiftTableInfo(queryTableId));
      }
    }, [queryAgentId, queryTableId]);

    const moreProps = {
      queryAgentId,
      queryTableId,
      agentTableId,
      agentStaffId,
      queryAgentToken,
      hasHydrated
    };

    const inAdminPage = window.location.href.includes(
      ADMIN_QUERIES.AGENT_STAFF
    );

    return inAdminPage && !hasHydrated ? (
      <Loader show />
    ) : (
      <Component {...moreProps} {...props} />
    );
  };
}
